// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"

Rails.start()
Turbolinks.start()

document.addEventListener("turbolinks:load", () => {
    let locale_default = 'en'
    $('.daterange').daterangepicker({
        showDropdowns: true,
        ranges: {
            'Today': [moment(), moment()],
            'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'Last 7 Days': [moment().subtract(6, 'days'), moment()],
            'Last 30 Days': [moment().subtract(29, 'days'), moment()],
            'This Month': [moment().startOf('month'), moment().endOf('month')],
            'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        },
        alwaysShowCalendars: true,
        opens: 'left',
        locale: {
            format: 'DD.MM.Y'
        }
    })
    let kaminariSelect = $('#limit_form select')

    kaminariSelect.change(function(){
        let per = kaminariSelect.val();
        if($.cookie('limit') != per) {
            $.cookie('limit', per);
            $('#limit_form').submit();
        }
    });
});